import { Component, OnInit, Input } from '@angular/core';
import {
  UntypedFormBuilder,
  UntypedFormGroup,
  UntypedFormArray,
} from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { TranslateService } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';
import Swal from 'sweetalert2';

import { AuthService } from '@app/core/auth';
import { RfqService, RFQ } from '@app/core/quotes';
import { StaffService, Staff } from '@app/core/staff';
import { environment } from '@app/env-service';

@Component({
  selector: 'cnc-rfq-factory-admin-assignment',
  templateUrl: './rfq-factory-admin-assignment.component.html',
  styleUrls: ['./rfq-factory-admin-assignment.component.scss'],
})
export class RfqFactoryAdminAssignmentComponent implements OnInit {
  url :string = environment.url;
  loading :boolean = true;
  submitted :boolean = false;
  gettingRecords :boolean = true;
  formData :UntypedFormGroup;
  factoryAdmins :Staff[];
  pageTitle :string = '';
  @Input() rfq :RFQ;
  @Input() role :any;
  @Input() rfq_ids :any;

  constructor(
    public activeModal :NgbActiveModal,
    private fb :UntypedFormBuilder,
    private rfqService :RfqService,
    private toastr :ToastrService,
    private translate :TranslateService,
    public staffService :StaffService,
    public authService :AuthService,
  ) {}

  ngOnInit() {
    this.formData = this.fb.group({
      factory_admin: this.fb.array([]),
    });
    if (this.authService.loginUser.is_admin) {
      this.pageTitle = this.translate.instant('TITLES.ASSIGN_RFQ_ADMIN');
    } else {
      this.pageTitle = this.translate.instant('TITLES.ASSIGN_RFQ_MEMBER');
    }
    let role = this.role || 1;
    if (!this.role && this.authService.loginUser.is_admin == 1) {
      role = 8;
    }
    this.staffService.staff$.subscribe((staff :Staff[]) => {
      const fas :any = staff.filter((row :any) => {
        return row.role == role;
      });
      if (fas) {
        this.gettingRecords = false;
        this.factoryAdmins = fas;
        this.factoryAdmins.forEach((fa) => {
          const fas_control = this.formData.get(
            'factory_admin',
          ) as UntypedFormArray;
          let exist :any = false;

          if (this.rfq) {
            if (this.authService.loginUser.is_admin == 1) {
              exist = this.rfq.admins.find((row :any) => {
                return row.factory_admin_id == fa.id;
              });
            } else {
              exist = this.rfq.members.find((row :any) => {
                return row.staff_id == fa.id;
              });
            }
          }
          if (exist) {
            fas_control.push(this.fb.control(true));
          } else {
            fas_control.push(this.fb.control(''));
          }
        });
      }
      const ffas = this.formData.get('factory_admin') as UntypedFormArray;

      this.loading = false;
    });
  }

  onSubmit(assignToAll ?:boolean) {
    const fas = this.formData.value.factory_admin;
    const staffList = [];
    fas.forEach((fa, idx) => {
      if (fa) {
        staffList.push(this.factoryAdmins[idx].id);
      }
    });
    if (staffList.length == 0) {
      Swal.fire({
        title: this.translate.instant('MESSAGES.RFQ_STAFF_ERROR.TITLE'),
        text: this.translate.instant('MESSAGES.RFQ_STAFF_ERROR.TEXT'),
        type: 'error',
        confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
      });

      return;
    }
    this.loading = true;
    if (this.rfq_ids) {
      return this.saveRfqs(staffList, assignToAll);
    }

    if (this.role) {
      const data :any = { members: staffList };
      if (assignToAll) {
        data.all = 1;
      }
      this.rfqService.setRfqSalesMembers(this.rfq.id, data).subscribe(
        (resp :any) => {
          this.toastr.success(
            this.translate.instant('MESSAGES.CREATE_SUCCESS.TEXT'),
            this.translate.instant('MESSAGES.CREATE_SUCCESS.TITLE'),
          );
          this.activeModal.close(resp.record);
        },
        (errorResp) => {
          this.loading = false;
          Swal.fire({
            title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
            text: errorResp.error.message,
            type: 'error',
            confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
          });
        },
      );
    } else {
      if (this.authService.loginUser.is_admin == 1) {
        const data :any = { fas: staffList };
        if (assignToAll) {
          data.all = 1;
        }
        this.rfqService.setRfqAdmins(this.rfq.id, data).subscribe(
          (resp :any) => {
            this.toastr.success(
              this.translate.instant('MESSAGES.CREATE_SUCCESS.TEXT'),
              this.translate.instant('MESSAGES.CREATE_SUCCESS.TITLE'),
            );
            this.activeModal.close(resp.record);
          },
          (errorResp) => {
            this.loading = false;
            Swal.fire({
              title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
              text: errorResp.error.message,
              type: 'error',
              confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
            });
          },
        );
      } else {
        const data :any = { members: staffList };
        if (assignToAll) {
          data.all = 1;
        }
        this.rfqService.setRfqMembers(this.rfq.id, data).subscribe(
          (resp :any) => {
            this.toastr.success(
              this.translate.instant('MESSAGES.CREATE_SUCCESS.TEXT'),
              this.translate.instant('MESSAGES.CREATE_SUCCESS.TITLE'),
            );
            this.activeModal.close(resp.record);
          },
          (errorResp) => {
            this.loading = false;
            Swal.fire({
              title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
              text: errorResp.error.message,
              type: 'error',
              confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
            });
          },
        );
      }
    }
  }

  saveRfqs(staffList :any, assignToAll ?:boolean) {
    if (this.role) {
      const data :any = { rfq_ids: this.rfq_ids, members: staffList };
      if (assignToAll) {
        data.all = 1;
      }

      this.rfqService.setBulkRfqSalesMembers(data).subscribe(
        (resp :any) => {
          this.toastr.success(
            this.translate.instant('MESSAGES.CREATE_SUCCESS.TEXT'),
            this.translate.instant('MESSAGES.CREATE_SUCCESS.TITLE'),
          );
          this.activeModal.close(resp.record);
        },
        (errorResp) => {
          this.loading = false;
          Swal.fire({
            title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
            text: errorResp.error.message,
            type: 'error',
            confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
          });
        },
      );
    } else {
      if (this.authService.loginUser.is_admin == 1) {
        const data :any = { rfq_ids: this.rfq_ids, fas: staffList };
        if (assignToAll) {
          data.all = 1;
        }

        this.rfqService.setBulkRfqAdmins(data).subscribe(
          (resp :any) => {
            this.toastr.success(
              this.translate.instant('MESSAGES.CREATE_SUCCESS.TEXT'),
              this.translate.instant('MESSAGES.CREATE_SUCCESS.TITLE'),
            );
            this.activeModal.close(resp.record);
          },
          (errorResp) => {
            this.loading = false;
            Swal.fire({
              title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
              text: errorResp.error.message,
              type: 'error',
              confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
            });
          },
        );
      } else {
        const data :any = { rfq_ids: this.rfq_ids, members: staffList };
        if (assignToAll) {
          data.all = 1;
        }

        this.rfqService.setBulkRfqMembers(data).subscribe(
          (resp :any) => {
            this.toastr.success(
              this.translate.instant('MESSAGES.CREATE_SUCCESS.TEXT'),
              this.translate.instant('MESSAGES.CREATE_SUCCESS.TITLE'),
            );
            this.activeModal.close(resp.record);
          },
          (errorResp) => {
            this.loading = false;
            Swal.fire({
              title: this.translate.instant('MESSAGES.SERVER_SAVE_ERROR.TITLE'),
              text: errorResp.error.message,
              type: 'error',
              confirmButtonText: this.translate.instant('BUTTONS.OKAY'),
            });
          },
        );
      }
    }
  }
}
